import Quiz2Screen from "@components/Onboarding/Intro/Quiz2Screen";

export default function Quiz2Route() {
  return <Quiz2Screen />;
}
